import { QueryClient, type QueryClientConfig } from '@tanstack/react-query'

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60,
      gcTime: 1000 * 60 * 60,
    },
  },
}

export function createHyredQueryClient() {
  return new QueryClient(queryClientConfig)
}
